<template>
  <div class="d-flex">
    <v-tooltip v-if="safeVoteCount" open-delay="300" location="top">
      <template #activator="{ props }">
        <div class="d-flex align-center" :class="{ 'mr-1': suspiciousVoteCount }" v-bind="props">
          <span class="caption text-green-dark">{{ safeVoteCount }}</span>
          <v-icon icon="$usersSaySafe" />
        </div>
      </template>
      {{ $t("general.tooltips.usersSaySafe") }}
    </v-tooltip>
    <v-tooltip v-if="suspiciousVoteCount" open-delay="300" location="top">
      <template #activator="{ props }">
        <div class="d-flex align-center" v-bind="props">
          <span class="caption text-red-dark">{{ suspiciousVoteCount }}</span>
          <v-icon icon="$usersSayPhishing" />
        </div>
      </template>
      {{ $t("general.tooltips.usersSayPhishing") }}
    </v-tooltip>
    <slot name="soc-status-label"></slot>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  suspiciousVoteCount?: number;
  safeVoteCount?: number;
}>();
</script>
